<template>
    <div>
        <div v-for="item in projNow" :key="item.id">
            <!-- Title page -->
            <div>
                <div class="title-img">
                    <img :src="require('../../assets/designProjects/' + item.img)">
                    <div class="title-img-overlay"></div>
                </div>
                <b-container fluid class="title-des">
                    <b-col class="col-lg-3 col-md-4 col-sm-6">
                        <h1 class="text-info text-left">{{ item.title }}</h1>
                        <p class="text-white">{{ item.description }}</p>
                    </b-col>
                </b-container>
            </div>
            <!-- Header -->
            <Header></Header>
            <!-- Project Info -->
            <b-container class="d-none d-lg-block d-xl-block content-left">
                <b-col class="col-lg-2">
                    <div class="my-5">    
                        <h5 class="text-info">Type</h5>
                        <p>{{ item.type }} <br>{{ item.skill }}</p>
                    </div>
                    <div class="my-5">    
                        <h5 class="text-info">Duration</h5>
                        <p>{{ item.time }} <br>{{ item.duration }}</p>
                    </div>
                    <div class="my-5">    
                        <h5 class="text-info">Team</h5>
                        <p>Akari Takada <br>Jack Eichenlaub <br>Victor Verboom <br>Tomasso Silluzio <br>Nancy Luu <br>Miriam Lluva</p>
                    </div>
                    <!-- <div class="my-5">
                        <h5 class="text-info">Skills</h5>
                        <p>edit here</p>
                    </div> -->
                </b-col>
            </b-container>
            <!-- Overview -->
            <b-container class="my-5">
                <h2 class="my-4 text-light">Overview</h2>
                <b-col class="my-2 col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row>
                        <b-col class="my-2 w-430">
                            <h5 class="text-info">Context</h5>
                            <h3>"To me, gaming means escape."</h3>
                            <p>Boys' with Duchenne Muscular Disease (DMD) face physical challenges due to a rapid decline of muscle function. To these boys, gaming is a gateway to independence. </p>
                        </b-col>
                    </b-row>
                    <b-row class="my-2">
                        <img class="rounded-img" src="../../assets/designProjects/evo/context.png" alt="">
                    </b-row>
                </b-col>
            </b-container>
            <!-- Problem -->
            <b-container class="bg-custom py-5 my-5">
                <b-col class="my-2 col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row>
                        <b-col class="my-2 w-430">
                            <h5 class="text-info">Problem</h5>
                            <h3>Two extremes.</h3>
                            <p>Mainstream controllers are desireable but uncomfortable. Untraditional adaptive controllers are highly-customizable but costly and complex.</p>
                        </b-col>
                    </b-row>
                    <b-row class="my-2">
                        <b-col md class="my-2 p-0 mr-md-4"><img class="rounded-img" src="../../assets/designProjects/evo/traditional-controller.jpg" alt=""></b-col>
                        <b-col md class="my-2 p-0 mr-md-4"><img class="rounded-img" src="../../assets/designProjects/evo/adaptive-controller.png" alt=""></b-col>
                    </b-row>
                </b-col>
            </b-container>
            <b-container class="bg-problem py-5 my-5">
                <h3 class="text-white m-0">How can we support DMD gamers' in their period of transition?</h3>
            </b-container>
            <!-- Solution -->
            <b-container class="my-5">
                <b-col class="my-2 col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row>
                        <b-col class="my-2 w-430">
                            <h5 class="text-info">Solution</h5>
                            <h3>EVO.</h3>
                            <p>A non-stigmatizing, ergonomic, and highly customizable game controller that evolves with DMD gamers.</p>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col class="my-2 col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row class="banner">
                        <div>
                            <img class="rounded-img" src="../../assets/designProjects/evo/3-orientation.png" alt="">
                            <div class="banner-img-overlay"></div>
                        </div>
                        <div class="banner-des w-430">
                            <h4 class="text-white">A controller that can be ‘held’ and ‘placed’.</h4>
                            <p class="text-white">Allows DMD gamers to play while resting their arms on a table.</p>
                        </div>
                    </b-row>
                </b-col>
                <b-col class="my-5 col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row>
                        <b-col md class="my-2">
                            <div>
                                <h4>Minimized travel distance.</h4>
                                <p>Easier to reach triggers/bumpers for DMD gamers who find it hard to bend the second joint of their finger. </p>
                            </div>
                            <div>
                                <img src="../../assets/designProjects/evo/travel-distance.svg" alt="">
                            </div>
                        </b-col>
                        <b-col md class="my-2">
                            <div>
                                <h4>Lighter buttons and joysticks.</h4>
                                <p>Eliminates the main cause of discomfort with mainstream controllers. </p>
                            </div>
                            <div>
                                <img src="../../assets/designProjects/evo/activation-force.svg" alt="">
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col class="my-5 col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row class="banner">
                        <div>
                            <img class="rounded-img" src="../../assets/designProjects/evo/EVO-prototype.png" alt="">
                            <div class="banner-img-overlay"></div>
                        </div>
                        <div class="banner-des w-430">
                            <h4 class="text-white">More options to experiment with.</h4>
                            <p class="text-white">The customizable joystick caps allows DMD gamers’ to find the optimal setup without spending extra.</p>
                        </div>
                    </b-row>
                </b-col>
            </b-container>
            <!-- Process -->
            <b-container class="my-5">
                <b-col class="col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row>
                    <a v-b-toggle:collapse-process class="toggle-link mt-5">
                        <h2 class="mt-5 mb-4">Process</h2>
                    </a>
                    </b-row>
                </b-col>
                <b-collapse id="collapse-process">
                    <b-col class="col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row class="content-grp">
                        <div class="content-txt my-2">
                            <h5 class="text-info">Context</h5>
                            <h3>"To me, gaming means escape."</h3>
                            <p>Boys' with Duchenne Muscular Disease (DMD) face physical challenges due to a rapid decline of muscle function. To these boys, gaming is a gateway to independence. </p>
                        </div>
                        <div>
                            <img src="../../assets/designProjects/evo/context.png" alt="">
                        </div>
                    </b-row>
                    </b-col>
                </b-collapse>
            </b-container>
        </div>
        <footerProjects></footerProjects>
    </div>
</template>

<script>
import csvData from '../../data/designProjectInfo.csv'
const Header = () => import('../../components/Header.vue')
const footerProjects = () => import('../../components/footerProjects.vue')

  var now = 'evo';

  export default {
    name: 'evo',
    title: 'EVO',
    components: {
      'Header': Header,
      'footerProjects': footerProjects,
    },
    data: () => {
      return {
        items : csvData
      }
    },
    computed: {
      projNow() {
        return this[this.$i18n.locale].filter((item) => item.code == now);
      },
      ja() {
        return this.items.filter((item) => item.lang == 'ja' );
      },
      en() {
        return this.items.filter((item) => item.lang == 'en');
      },
      path() {
        return this.item.path;
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" src="@/scss/designProjects.scss">
</style>